import { useHistory } from "react-router-dom";

type LocationState = {} | null | undefined;

export const useNavigate = () => {
  const history = useHistory();

  return (path: string, state?: LocationState) => history.push(path, state);
};
